
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 19.6l-5-2.9a1.955 1.955 0 01-.737-.737A1.969 1.969 0 015 14.975v-5.8c0-.35.088-.68.263-.988.175-.308.42-.554.737-.737l5-2.9c.317-.183.65-.275 1-.275s.683.092 1 .275l5 2.9a1.974 1.974 0 011 1.725v5.8a1.974 1.974 0 01-1 1.725l-5 2.9c-.317.183-.65.275-1 .275s-.683-.092-1-.275zM1 6V4c0-.833.292-1.542.875-2.125A2.893 2.893 0 014 1h2v2H4a.967.967 0 00-.712.287A.968.968 0 003 4v2H1zm3 17a2.893 2.893 0 01-2.125-.875A2.893 2.893 0 011 20v-2h2v2c0 .283.096.52.288.712A.965.965 0 004 21h2v2H4zm14 0v-2h2c.283 0 .52-.096.712-.288A.965.965 0 0021 20v-2h2v2c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0120 23h-2zm3-17V4a.968.968 0 00-.288-.713A.967.967 0 0020 3h-2V1h2c.833 0 1.542.292 2.125.875S23 3.167 23 4v2h-2zM8 8.6l-1 .575v1.175l4 2.3v4.6l1 .575 1-.575v-4.6l4-2.3V9.175L16 8.6l-4 2.3-4-2.3z","fill":"#fff"}})])
          )
        }
      }
    